// API 설정 파일
export const API_CONFIG = {
  // 환경별 API 기본 URL
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8003',
  
  // API 타임아웃 설정 (밀리초)
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000'),
  
  // JWT 토큰 설정
  JWT_SECRET: process.env.REACT_APP_JWT_SECRET || 'SflkFuUw_cRhi8zD9as6leyk_-XbehKv5u5kLa8sq8gSFbt0Y-y-q1OEhWPO38_5',
  
  // 토스페이먼츠 설정
  TOSS: {
    CLIENT_KEY: process.env.REACT_APP_TOSS_CLIENT_KEY || 'test_gck_nRQoOaPz8LwvbMldQNWGry47BMw6',
    SECRET_KEY: process.env.REACT_APP_TOSS_SECRET_KEY || 'test_gsk_Z1aOwX7K8me0eDG5dZjj8yQxzvNP',
    API_URL: process.env.REACT_APP_TOSS_API_URL || 'https://api.tosspayments.com',
  },
  
  // 소셜 로그인 설정
  SOCIAL: {
    NAVER: {
      CLIENT_ID: process.env.REACT_APP_NAVER_CLIENT_ID || '2DUTnbwlyOdEQjinMT6N',
      CLIENT_SECRET: process.env.REACT_APP_NAVER_CLIENT_SECRET || 'bZtoAAEHoj',
    },
    KAKAO: {
      REST_API_KEY: process.env.REACT_APP_KAKAO_REST_API_KEY || 'bb3e427a7e39fc028b65b2d0c8e40460',
    },
    APPLE: {
      BUSINESS_CLIENT_ID: process.env.REACT_APP_APPLE_BUSINESS_CLIENT_ID || 'com.mungtoday.store.dev.service',
      CUSTOMER_CLIENT_ID: process.env.REACT_APP_APPLE_CUSTOMER_CLIENT_ID || 'com.mungtoday.app.dev.service',
    },
  },
  
  // AWS S3 설정
  AWS: {
    REGION: process.env.REACT_APP_AWS_REGION || 'ap-northeast-2',
    S3_BUCKET: process.env.REACT_APP_AWS_S3_BUCKET || 'mungtoday',
  },
  
  // 환경 정보
  ENV: process.env.REACT_APP_ENV || 'development',
};

// API 엔드포인트 정의
export const API_ENDPOINTS = {
  // 인증 관련
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh',
    VERIFY: '/api/auth/verify',
  },
  
  // 회원 관리
  MEMBERS: {
    LIST: '/api/members',
    DETAIL: (id: string) => `/api/members/${id}`,
    UPDATE: (id: string) => `/api/members/${id}`,
    DELETE: (id: string) => `/api/members/${id}`,
  },
  
  // 사업자 관리
  BUSINESS: {
    LIST: '/api/business',
    DETAIL: (id: string) => `/api/business/${id}`,
    UPDATE: (id: string) => `/api/business/${id}`,
    DELETE: (id: string) => `/api/business/${id}`,
  },
  
  // 알림 관리
  NOTIFICATIONS: {
    LIST: '/api/admin/notifications',
    DETAIL: (id: string) => `/api/admin/notifications/${id}`,
    SEND: '/api/admin/notifications/send',
    UPDATE: (id: string) => `/api/admin/notifications/${id}`,
    DELETE: (id: string) => `/api/admin/notifications/${id}`,
    STATS: '/api/admin/notifications/stats',
  },
  
  // 결제 정보
  PAYMENTS: {
    LIST: '/api/payments',
    DETAIL: (id: string) => `/api/payments/${id}`,
    INFO: '/api/payments/info',
  },
  
  // 정산 정보
  SETTLEMENTS: {
    LIST: '/api/settlements',
    DETAIL: (id: string) => `/api/settlements/${id}`,
    INFO: '/api/settlements/info',
  },

  // 사업자 메뉴 관리
  ADMIN_BUSINESS_MENU: {
    MENU_LIST: '/admin/business/menu',
    MENU_SAVE: '/admin/business/menu',
    MENU_DELETE: '/admin/business/menu',
    PERMISSIONS_LIST: '/admin/business/menu/permissions',
    PERMISSIONS_SAVE: '/admin/business/menu/permissions',
    PERMISSIONS_DELETE: '/admin/business/menu/permissions',
    TARGET_URL_LIST: '/admin/business/menu/permissions/target',
    TARGET_URL_SAVE: '/admin/business/menu/permissions/target',
    TARGET_URL_DELETE: '/admin/business/menu/permissions/target',
  },

  // 크레딧·크레딧 관리
  ADMIN_CREDIT: {
    STATS:               '/admin/credit/stats',
    COMPANY_LIST:        '/admin/credit/companies',
    COMPANY_DETAIL:      (companySeq: number | string) => `/admin/credit/companies/${companySeq}`,
    COMPANY_USAGE:       (companySeq: number | string) => `/admin/credit/companies/${companySeq}/usage`,
    COMPANY_GRANT:       (companySeq: number | string) => `/admin/credit/companies/${companySeq}/grant`,
    COMPANY_DEDUCT:      (companySeq: number | string) => `/admin/credit/companies/${companySeq}/deduct`,
    COMPANY_PLAN:        (companySeq: number | string) => `/admin/credit/companies/${companySeq}/plan`,
    COMPANY_EXEMPT:      (companySeq: number | string) => `/admin/credit/companies/${companySeq}/exempt`,
    BULK_GRANT:          '/admin/credit/bulk-grant',
    PRICE_LIST:          '/admin/credit/prices',
    PRICE_CREATE:        '/admin/credit/prices',
    PRICE_UPDATE:        (priceSeq: number | string) => `/admin/credit/prices/${priceSeq}`,
    PRICE_KNOWN_TYPES:   '/admin/credit/prices/known-types',
    POLICY_LIST:         '/admin/credit/policies',
    POLICY_UPDATE:       (policyKey: string) => `/admin/credit/policies/${policyKey}`,
    PACKAGE_LIST:        '/admin/credit/packages',
    PACKAGE_CREATE:      '/admin/credit/packages',
    PACKAGE_UPDATE:      (packageSeq: number | string) => `/admin/credit/packages/${packageSeq}`,
    PACKAGE_DEACTIVATE:  (packageSeq: number | string) => `/admin/credit/packages/${packageSeq}`,
    PACKAGE_ACTIVATE:    (packageSeq: number | string) => `/admin/credit/packages/${packageSeq}/activate`,
    PACKAGE_REORDER:     '/admin/credit/packages/reorder',
    PLAN_LIST:           '/admin/credit/plans',
    CHANGE_LIST:         '/admin/credit/changes',
    TX_REVERSE:          (txSeq: number | string) => `/admin/credit/transactions/${txSeq}/reverse`,
    COMPANY_BULK_REVERSE:(companySeq: number | string) => `/admin/credit/companies/${companySeq}/bulk-reverse`,
  },

  // 대시보드 (운영 현황 집계)
  ADMIN_DASHBOARD: {
    ALERTS:  '/admin/dashboard/alerts',
    SUMMARY: '/admin/dashboard/summary',
  },

  // 매출 (본사 실매출 — 크레딧 충전 + 온라인 서비스수수료)
  ADMIN_REVENUE: {
    SUMMARY: '/admin/revenue',
    FEE_RATES: '/admin/revenue/fee-rates', // 전사 기본 수수료율(PG·서비스) 조회/저장
  },
};

// HTTP 상태 코드
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

